import type { FC } from 'react';

import { Divider, Skeleton } from '@mint-lib/tw-components';

const FlowPageSkeleton: FC = () => {
  return (
    <div className="">
      <div className="mb-3 flex items-center justify-between gap-4">
        <div className="grow">
          <Skeleton className="h-4 w-full max-w-50" variant="rounded" />
        </div>
        <div className="flex basis-60 items-center justify-end gap-2">
          <Skeleton className="h-4 w-full max-w-40" variant="rounded" />
          <Divider className="h-6!" orientation="vertical" />
          <Skeleton className="h-8 w-14" variant="rounded" />
        </div>
      </div>
      <Skeleton variant="rounded" className="mb-8 h-8 w-full max-w-60" />
      <div className="mb-8 flex gap-4">
        <Skeleton className="h-4 w-35" variant="rounded" />
        <Skeleton className="h-4 w-22" variant="rounded" />
        <Skeleton className="h-4 w-20" variant="rounded" />
      </div>
      <Skeleton className="mb-2 h-5 w-30" variant="rounded" />
      <Skeleton className="mb-4 h-4 w-full max-w-100" variant="rounded" />
      <div className="grid grid-cols-2 gap-x-2 gap-y-14">
        <div>
          <Skeleton className="mb-1 h-4 w-16" variant="rounded" />
          <Skeleton className="h-10 w-full" variant="rounded" />
        </div>
        <div>
          <Skeleton className="mb-1 h-4 w-16" variant="rounded" />
          <Skeleton className="h-10 w-full" variant="rounded" />
        </div>
        <div>
          <Skeleton className="mb-1 h-4 w-19" variant="rounded" />
          <Skeleton className="h-10 w-full" variant="rounded" />
        </div>
        <div>
          <Skeleton className="mb-1 h-4 w-22" variant="rounded" />
          <Skeleton className="h-10 w-full" variant="rounded" />
        </div>
      </div>
    </div>
  );
};

export default FlowPageSkeleton;
